export default __webpack_public_path__ + "static/cargo-truck-f2bed0f1bbca5656351173ab8219f9fb.jpeg";